export const safetyStatementsHeader = [
	{
		settings: true,
		text: "ID",
		value: "id",
		valueFilter: 'filter_id',
		model: { value: 'list' },
		func: true,
		sortable: true,
		footer: "unique"
	},
	{
		settings: true,
		text: "Created by",
		value: "created_by",
		valueFilter: 'filter_created_by',
		model: { value: 'list' },
		func: true,
		sortable: true,
	},
	{
		settings: true,
		text: "End month date",
		value: "end_month_date",
		valueFilter: 'filter_end_month_date',
		model: { value: 'date' },
		func: true,
		sortable: true,
	},
	{
		settings: true,
		text: "Employee",
		value: "employee",
		valueFilter: 'filter_employee',
		model: { value: 'list' },
		func: true,
		sortable: true,
	},
	{
		settings: true,
		text: "Salary",
		value: "salary",
		valueFilter: 'filter_salary',
		model: { value: 'number' },
		func: false,
		sortable: true,
		dollar: true,
		footer: "sum"
	},
	{
		settings: true,
		text: "Bonus",
		value: "bonus",
		valueFilter: 'filter_bonus',
		func: false,
		model: { value: 'number' },
		sortable: true,
		dollar: true,
		footer: "sum"
	},
	{
		settings: true,
		text: "Total",
		value: "total",
		valueFilter: 'filter_total',
		func: false,
		model: { value: 'number' },
		sortable: true,
		dollar: true,
		footer: "sum"
	},
	{
		settings: true,
		buttons: [
			{
				perm: { or: [ 10 ] },
				value: 'openLoads',
				text: 'St-t',
				icon: { value: 'icon_view', w: 17, h: 14 },
			},
			{
				perm: { or: [ 11 ] },
				value: 'delete',
				text: 'Delete',
				icon: { value: 'deleteItem', w: 18, h: 18 },
			}
		]
	},
];
export const safetyStatementsHeaderUser = [
	{
		settings: true,
		text: "ID",
		value: "id",
		valueFilter: 'filter_id',
		model: { value: 'list' },
		func: true,
		sortable: true,
		footer: "unique"
	},
	{
		settings: true,
		text: "Created by",
		value: "created_by",
		valueFilter: 'filter_created_by',
		model: { value: 'list' },
		func: true,
		sortable: true,
	},
	{
		settings: true,
		text: "Month",
		value: "month",
		valueFilter: 'filter_month',
		model: { value: 'date' },
		func: true,
		sortable: true,
	},

	// {
	// 	settings: true,
	// 	text: "Employee",
	// 	value: "employee",
	// 	valueFilter: 'filter_employee',
	// 	model: { value: 'list' },
	// 	func: true,
	// 	sortable: true,
	// },
	{
		settings: true,
		text: "Salary",
		value: "salary",
		valueFilter: 'filter_salary',
		model: { value: 'number' },
		func: false,
		sortable: true,
		dollar: true,
		footer: "sum"
	},
	{
		settings: true,
		text: "Bonus",
		value: "bonus",
		valueFilter: 'filter_bonus',
		func: false,
		model: { value: 'number' },
		sortable: true,
		dollar: true,
		footer: "sum"
	},
	{
		settings: true,
		text: "Total",
		value: "total",
		valueFilter: 'filter_total',
		func: false,
		model: { value: 'number' },
		sortable: true,
		dollar: true,
		footer: "sum"
	},
	{
		settings: true,
		buttons: [
			{
				perm: true,
				value: 'openLoads',
				text: 'St-t',
				icon: { value: 'icon_view', w: 17, h: 14 },
			},
			// {
			// 	perm: { or: [ 11 ] },
			// 	value: 'delete',
			// 	text: 'Delete',
			// 	icon: { value: 'deleteItem', w: 18, h: 18 },
			// }
		]
	},
];

export const safetyStatementsCreateHeader = [
	{ isCheckbox: true, isCheckboxAll: true, isCheckboxTotal: true },
	{
		text: "ID",
		value: "user_id",
		sortable: true,
		footer: "unique"
	},
	{
		text: "Employee",
		value: "employee",
		valueFilter: 'filter_employee',
		model: { value: 'list' },
		func: true,
		sortable: true,
	},
	{
		text: "Salary",
		value: "salary",
		sortable: true,
		footer: "sum"
	},
	{
		text: "Bonus",
		value: "bonus",
		sortable: true,
		footer: "sum"
	},
	{
		text: "Charge",
		value: "charge",
		sortable: true,
		footer: "sum"
	},
	{
		text: "Total",
		value: "total",
		sortable: true,
		dollar: true,
		footer: "sum"
	},
	{
		buttons: [
			{
				perm: true,
				value: 'openLoads',
				text: 'View st-t',
				icon: { value: 'icon_view', w: 17, h: 14 },
			}
		]
	},
];

export const safetyStatementsViewHeader = [
	{
		text: "Date",
		value: "date",
		sortable: true,
	},
	{
		text: "Type",
		value: "type",
		sortable: true,
	},
	{
		text: "Description",
		value: "description",
		sortable: true,
	},
	{
		text: "Action q-ty",
		value: "count_action",
		sortable: true,
	},
	{
		text: "Shift#",
		value: "schedule",
		sortable: true,
	},
	{
		text: "Amount",
		value: "amount",
		sortable: true,
		dollar: true,
		footer: "sumDifference"
	}
];
